import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

// Honest, verifiable coverage stats — no fabricated partner/sponsor logos.
// These numbers match the site-wide coverage figures (footer, SEO, GaragesPage).
const STATS = [
  { value: '4,700+', label: 'garages scored' },
  { value: '350+', label: 'venues covered' },
  { value: '196', label: 'cities' },
  { value: '4', label: 'exit directions ranked' },
];

export default function TrustedBy() {
  return (
    <section className="bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <p className="text-center text-xs font-bold uppercase tracking-wider text-gray-400">
          Independent exit scores for every garage we cover
        </p>
        <div className="mt-8 grid grid-cols-2 gap-y-8 sm:flex sm:flex-wrap sm:items-start sm:justify-center sm:gap-x-14">
          {STATS.map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-3xl font-extrabold text-gray-900 tabular-nums">{s.value}</div>
              <div className="mt-1 text-sm text-gray-500">{s.label}</div>
            </div>
          ))}
        </div>
        <div className="mt-8 flex justify-center">
          <Link
            to="/venues"
            className="inline-flex items-center gap-1 text-sm font-semibold"
            style={{ color: '#17A24A' }}
          >
            Browse all venues
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
